import React, { Component } from 'react';
import { post } from '@aws-amplify/api';
import Utils from './../../utils.js';

class Summary extends Component {
	state = {
		showRedirectMessage: false,
		showSpinner: false
	};

	constructor(props) {
		super(props);
		this.state = {
			isSubmit: false
		};
	}

	isValidated() {
		if (this.state.isSubmit === true) {
			return false;
		}

		if (this.props.getStore().consumerName === null) {
			this.setState({ isSubmit: true });
			return false;
		}

		if (this.props.getStore().isSubmit === true) {
			this.setState({ isSubmit: true });
			return false;
		}

	};

	// Method to check if all required fields are filled
	areAllFieldsValid = () => {
		const data = this.props.getStore();
		const requiredFields = ['consumerName', 'productName', 'adGroup', 'buildEnvironment'];

		return requiredFields.every(field =>
			data[field] && data[field].toString().trim() !== ''
		);
	};

	componentDidMount() {

		if (this.props.getStore().isSubmit === true) {
			this.setState({ isSubmit: true });
			return false;
		}

		if (this.props.getStore().consumerName === null || this.props.getStore().consumerName === "") {
			this.setState({ isSubmit: true });
			return false;
		}

		if (this.props.getStore().productName === null || this.props.getStore().productName === "") {
			this.setState({ isSubmit: true });
			return false;
		}
	}

	onSubmit = async (e) => {
		e.preventDefault();
		this.setState({ isSubmit: true, showSpinner: true }); // Show spinner immediately
		let data = this.props.getStore();

		// Validate required fields
		const requiredFields = [
			{ field: 'consumerName', name: 'Consumer Name' },
			{ field: 'productName', name: 'Proxy Group Name' },
			{ field: 'adGroup', name: 'AD Group' },
			{ field: 'buildEnvironment', name: 'Build Environment' }
		];

		const missingFields = requiredFields.filter(({ field }) =>
			!data[field] || data[field].toString().trim() === ''
		);

		if (missingFields.length > 0) {
			const missingFieldNames = missingFields.map(({ name }) => name).join(', ');
			alert(`Please fill in all required fields: ${missingFieldNames}`);
			this.setState({ isSubmit: false, showSpinner: false });
			return;
		}

		// Filter appId JSON to only include selected build environments
		let filteredAppId = data.appId;
		if (data.appId && data.buildEnvironment) {
			try {
				const allAppIds = JSON.parse(data.appId);
				const selectedEnvs = data.buildEnvironment.split(',').map(env => env.trim());
				const filteredAppIds = {};

				selectedEnvs.forEach(env => {
					if (allAppIds[env]) {
						filteredAppIds[env] = allAppIds[env];
					}
				});

				filteredAppId = JSON.stringify(filteredAppIds);
			} catch (e) {
				console.error('Error parsing appId JSON:', e);
			}
		}

		const apiName = 'Send Product Approval API';
		const path = '/send-product-approval';
		try {

			const buildBody = {
				proxyGroupName: data.productName,
				adGroup: data.adGroup,
				buildEnvironment: data.buildEnvironment,
				appId: filteredAppId,
				consumerName: data.consumerName,
				domainName: window.location.hostname,
				createdAt: Date.now().toString()
			};

			// Await the response and access the body
    		const response = await Utils.fetchLambdaApis(apiName, path, buildBody);

			// Handle the workflow response
			return this.handleWorkflowResponse(response);

		} catch (error) {
			console.error('API error:', error);
			if (error.response && error.response.body) {
				try {
					const errorResponseData = await error.response.body.json();
					console.error('Error response body:', errorResponseData);
				} catch (parseError) {
					console.error('Could not parse error response body:', error.response.body);
				}
			}
			alert('Failed to trigger workflow. Please try again.');
			this.setState({ isSubmit: false, showSpinner: false }); // Hide spinner only on error
		}
	};

	handleWorkflowResponse = (response) => {
		const workflowRunUrl = response.workflowRunUrl;
		if (workflowRunUrl) {
			this.setState({ showRedirectMessage: true });
			setTimeout(() => {
				window.location.href = workflowRunUrl;
			}, 200);
		} else {
			console.error('Workflow Run URL not found in response:', response);
			this.setState({ showSpinner: false }); // Hide spinner if no redirect
			alert('Workflow triggered, but could not find the workflow run URL.');
		}
	};

	render() {
		let data = this.props.getStore();
		return (
			<div style={{ position: 'relative' }}>
				{this.state.showSpinner && (
					<>
						<div style={{
							position: 'fixed',
							top: 0,
							left: 0,
							width: '100vw',
							height: '100vh',
							background: 'rgba(255,255,255,0.7)',
							zIndex: 9999,
							backdropFilter: 'blur(3px)',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
						>
							<div style={{ textAlign: 'center' }}>
								<div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60, marginBottom: 20 }}>
									<span className="sr-only">Loading...</span>
								</div>
								<div style={{ fontWeight: 'bold', color: '#007bff', fontSize: 18 }}>
									Please wait while we redirect you to GitHub...
								</div>
							</div>
						</div>
					</>
				)}
				<div style={this.state.showSpinner ? { filter: 'blur(3px)', pointerEvents: 'none', userSelect: 'none' } : {}}>
					<div className="container util-margin-top-50">
						{!this.areAllFieldsValid() && (
							<p className="alert alert-danger util-margin-top-10">
								<strong>Missing Information:</strong> Some parameters are missing. Please provide all required information to proceed with the submission.
							</p>
						)}
						<hr />
						<div className="row">
							<div className="col-md-3">
								<span>Proxy Group Name: </span>
							</div>
							<div className="col-md-6">
								<span>{data.productName}</span>
							</div>
						</div>
						<hr />
						<div className="row">
							<div className="col-md-3">
								<span>AD Group: </span>
							</div>
							<div className="col-md-6">
								<span>{data.adGroup}</span>
							</div>
						</div>
						<hr />
						<div className="row">
							<div className="col-md-3">
								<span>Consumer Name: </span>
							</div>
							<div className="col-md-6">
								<span>{data.consumerName}</span>
							</div>
						</div>
						<hr />
						<div className="row">
							<div className="col-md-3">
								<span>App ID: </span>
							</div>
							<div className="col-md-6">
								{data.appId ? (
									(() => {
										try {
											const allAppIds = JSON.parse(data.appId || '{}');
											const selectedEnvs = data.buildEnvironment ? data.buildEnvironment.split(',').map(env => env.trim()) : [];
											const filteredAppIds = {};

											selectedEnvs.forEach(env => {
												if (allAppIds[env]) {
													filteredAppIds[env] = allAppIds[env];
												}
											});

											return (
												<div>
													{Object.keys(filteredAppIds).length > 0 ? (
														Object.keys(filteredAppIds).map((env) => (
															<div key={env} style={{ marginBottom: '5px' }}>
																<strong>{env}:</strong> {filteredAppIds[env]}
															</div>
														))
													) : (
														<span>No App IDs available</span>
													)}
												</div>
											);
										} catch (e) {
											return <span>{data.appId}</span>;
										}
									})()
								) : (
									<span>-</span>
								)}
							</div>
						</div>
						<hr />
						<div className="row">
							<div className="col-md-3">
								<span>Build Environment: </span>
							</div>
							<div className="col-md-6">
								<span>{data.buildEnvironment}</span>
							</div>
						</div>
					</div>
					<button
						disabled={this.state.isSubmit || !this.areAllFieldsValid()}
						className="btn btn-primary btn-sm pull-right util-margin-top-50"
						onClick={this.onSubmit}
					>
						Submit
					</button>
				</div>
			</div>
		);
	}
}

export default Summary;